import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PublicRoute = () => {
  if (localStorage.getItem('ACCESS_TOKEN')) {
    return <Navigate to="/manage-employer" replace />;
  }

  return <Outlet />;
};

export default PublicRoute;